import { createFileRoute } from '@tanstack/react-router'
import { GuidePage } from '@/features/guide/guide-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/guide')({
  component: GuideRoute,
})

function GuideRoute() {
  const { workspaceSlug } = Route.useParams()

  return <GuidePage workspaceSlug={workspaceSlug} />
}
